import { defineNuxtPlugin } from "#app";
import { useMainStore } from "~/store/mainState";

export default defineNuxtPlugin({
    parallel: true,
    setup: (nuxtApp) => {
        if (!window) {
            return;
        }

        const mainStore = useMainStore();

        window.onfocus = () => {
            mainStore.ping();
        };
    },
});
